import { Component } from '@angular/core';

@Component({
  selector: 'admin-faq',
  imports: [],
  templateUrl: './faq.html',
  styleUrl: './faq.scss',
})
export class Faq {

}
